import { createSlice } from "@reduxjs/toolkit";
import { schemeDetailsApiSlice } from "./api";

export const initialState = {
  query: {},
  variantTest: {},
  availableVariantsKeys: {},
  is_available_to_buy: false,
  one: {},
  schemeDetails: {},
  officeOptions: [],
};

const schemeDetailsSlice = createSlice({
  name: "schemeDetails",
  initialState,
  reducers: {
    setQueryValue: (state, action) => {
      if (action.payload.key) {
        state.query[action.payload.key] = action.payload.value;
      } else {
        state.query = action.payload;
      }
    },
    setOneValue: (state, action) => {
      state.one[action.payload.key] = action.payload.value;
    },
    clearOne: (state, action) => {
      state.one = initialState.one;
    },
    setSelectVarirant: (state, { payload }) => {
      state.variantTest[payload.inventory_type] = payload.inventory_value;
      let newVariantTestObj = {
        ...state.variantTest,
        [payload.inventory_type]: payload.inventory_value,
      };
      let requiredSku = Object.values(newVariantTestObj).join("-");
      const reqVariantObj = state.schemeDetails?.main_product?.variant?.find(
        (x) => x.sku_of_seller === requiredSku
      );
      state.one.variant_id = reqVariantObj;
      // check if the product is valid to buy
      if (reqVariantObj?.is_available) {
        if (reqVariantObj?.inventory <= 0) {
          state.is_available_to_buy = false;
        }
        state.is_available_to_buy = true;
      } else {
        state.is_available_to_buy = false;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        schemeDetailsApiSlice.endpoints.loadPublicSchemeDetails.matchFulfilled,
        (state, { payload }) => {
          if (payload.data) {
            state.schemeDetails = payload.data;
            const reqVariantObj = payload.data.main_product?.variant?.[0];
            state.one.variant_id = reqVariantObj;

            // check if the product is valid to buy
            if (reqVariantObj?.is_available) {
              if (reqVariantObj?.inventory <= 0) {
                state.is_available_to_buy = false;
              }
              state.is_available_to_buy = true;
            } else {
              state.is_available_to_buy = false;
            }

            if (payload.data?.main_product?.is_multiple_variation) {
              state.variantTest =
                payload.data?.main_product?.inventory_type?.reduce(
                  (acc, curr) => ({
                    ...acc,
                    [curr.inventory_type]: curr.option[0],
                  }),
                  {}
                ) || {};
            }
          }
        }
      )
      .addMatcher(
        schemeDetailsApiSlice.endpoints.loadPublicOfficeOptions.matchFulfilled,
        (state, { payload }) => {
          state.officeOptions = payload.data.map((x) => ({
            label: x.name,
            value: x._id,
          }));
        }
      );
  },
});

export const { setQueryValue, setOneValue, clearOne, setSelectVarirant } =
  schemeDetailsSlice.actions;

export default schemeDetailsSlice.reducer;
